import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useNetworkPricesStore } from '../NetworkPrices.store';
import { getNetworkPrices } from '../services';
import { NetworkPricesPage } from '../types';
import { buildNetworkPricesFilter } from '../utils';

export const NETWORK_PRICES_QUERY_KEY = 'ipa.network-prices';

export const useNetworkPricesQuery = (): UseQueryResult<NetworkPricesPage> => {
  const pagination = useNetworkPricesStore(state => state.pagination);
  const filters = useNetworkPricesStore(state => state.filters);
  const setPage = useNetworkPricesStore(state => state.setPage);
  // Key by the body, not the raw values: a cleaned chip leaves an empty list that sends the same request.
  const filter = buildNetworkPricesFilter(filters);

  return useQuery<NetworkPricesPage>({
    queryKey: [NETWORK_PRICES_QUERY_KEY, pagination, filter],
    queryFn: () => getNetworkPrices(pagination, filter),
    keepPreviousData: true,
    onSuccess: page => {
      if (page.content.length === 0 && pagination.page > 0) setPage(pagination.page - 1);
    },
  });
};
